module.exports = __webpack_public_path__ + "media/images/icons/caret-up-16be891726a7eb218ecf5ab7d92cb12d.svg";